import {
    ChangeDetectionStrategy,
    Component,
    CUSTOM_ELEMENTS_SCHEMA,
    inject,
} from "@angular/core";

import { toSignal } from "@angular/core/rxjs-interop";
import { filter, tap } from "rxjs";

import { ShellFacade } from "@hermes/domains-shell-states-shell-state";

import { FooterColumnsComponent } from "../footer-columns/footer-columns.component";
import { ReinsuranceFooterComponent } from "../reinsurance/reinsurance-footer/reinsurance-footer.component";
import { SubFooterComponent } from "../sub-footer/sub-footer.component";

@Component({
    selector: "h-footer",
    imports: [
        ReinsuranceFooterComponent,
        SubFooterComponent,
        FooterColumnsComponent,
    ],
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FooterComponent {
    private shellFacade = inject(ShellFacade);

    public footerItems = toSignal(
        this.shellFacade.footerItems$.pipe(
            tap((data) => {
                if (!data) {
                    this.shellFacade.fetchFooterItems();
                }
            }),
            filter((footerItems) => footerItems !== undefined),
        ),
        { initialValue: undefined },
    );

    public supportInfos = toSignal(
        this.shellFacade.supportInfos$.pipe(
            tap((data) => {
                if (!data) {
                    this.shellFacade.fetchSupportInfos();
                }
            }),
            filter((supportInfos) => supportInfos !== undefined),
        ),
        { initialValue: undefined },
    );
}
